import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  type PropsWithChildren
} from "react";
import { toggleCollapsible } from "./collapsibleUtility";

interface CollapsibleProps {
  id?: string;
  buttonId?: string;
  containerClass?: string;
  contentClass?: string;
  isOpen: boolean;
}

export const Collapsible = ({
  children,
  id,
  buttonId,
  containerClass,
  contentClass,
  isOpen
}: PropsWithChildren<CollapsibleProps>) => {
  const [open, setOpen] = useState(isOpen);
  const collapsibleRef = useRef<HTMLDivElement>(null);

  const triggerTransition = useCallback(() => {
    if (!!collapsibleRef.current) {
      toggleCollapsible(collapsibleRef.current, open);
    }
  }, [open, collapsibleRef]);

  useEffect(() => {
    if (isOpen !== open) {
      setOpen(isOpen);
      triggerTransition();
    } else {
      setOpen(isOpen);
    }
  }, [isOpen]);

  return (
    <div data-collapsible aria-expanded={isOpen}>
      <div
        ref={collapsibleRef}
        aria-labelledby={buttonId}
        data-collapsible-container
        className={`${containerClass || ""}`}
        id={id}
        role="region"
        style={{
          height: isOpen ? "auto" : "0px",
          overflow: isOpen ? "visible" : "hidden"
        }}
      >
        <div data-collapsible-content className={contentClass || ""}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Collapsible;
